"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snTheme = exports.snAnimatedTheme = exports.numberFormatter2Decimals = exports.numberFormatter1Decimals = exports.numberFormatter0Decimals = exports.WhiteColor = exports.GridColor = exports.BackgroundColor = exports.PrimaryOrangeColor = exports.PrimaryColor = exports.PrimaryTextColor = void 0;
var core_1 = require("@amcharts/amcharts4/core");
var charts_1 = require("@amcharts/amcharts4/charts");
var sv_SE_1 = __importDefault(require("@amcharts/amcharts4/lang/sv_SE"));
exports.PrimaryTextColor = core_1.color("#33414e");
exports.PrimaryColor = core_1.color("#62717F");
exports.PrimaryOrangeColor = core_1.color("#EA8F12");
exports.BackgroundColor = core_1.color("#F7F8FA");
exports.GridColor = core_1.color("#617180");
exports.WhiteColor = core_1.color("#fff");
exports.numberFormatter0Decimals = new core_1.NumberFormatter();
exports.numberFormatter0Decimals.numberFormat = "#,###.";
exports.numberFormatter1Decimals = new core_1.NumberFormatter();
exports.numberFormatter1Decimals.numberFormat = "#,###.0";
exports.numberFormatter2Decimals = new core_1.NumberFormatter();
exports.numberFormatter2Decimals.numberFormat = "#,###.00";
function snAnimatedTheme(target) {
    if (target instanceof charts_1.Chart) {
        var chart = target;
        // animation properties
        chart.defaultState.transitionDuration = 250;
    }
}
exports.snAnimatedTheme = snAnimatedTheme;
function snTheme(target) {
    if (target instanceof charts_1.Chart) {
        var chart = target;
        chart.paddingRight = 20;
        if (chart instanceof charts_1.XYChart) {
            chart.cursor = new charts_1.XYCursor();
        }
    }
    if (target instanceof core_1.Language) {
        var language = target;
        language.locale = sv_SE_1.default;
    }
    if (target instanceof charts_1.Legend) {
        var legend = target;
        // positioning
        legend.contentAlign = "center";
        legend.fontSize = "16px";
    }
    if (target instanceof core_1.ColorSet) {
        target.list = [
            exports.PrimaryColor,
            exports.PrimaryOrangeColor,
            core_1.color("#B12F26"),
            core_1.color("#A1AFBD"),
            core_1.color("#875891"),
            core_1.color("#EE6457"),
            core_1.color("#42B1B0"),
            core_1.color("#C85582"),
            core_1.color("#8CAFCE"),
            core_1.color("#836875"),
        ];
    }
    if (target instanceof charts_1.AxisRenderer) {
        var renderer = target;
        renderer.minWidth = 35;
        renderer.fontSize = "11px";
        renderer.labels.template.fill = exports.PrimaryColor;
        // grid
        renderer.grid.template.stroke = core_1.color(exports.GridColor);
        renderer.grid.template.strokeWidth = 0.5;
        renderer.grid.template.location = 0;
        if (target instanceof charts_1.AxisRendererX) {
            var renderer_1 = target;
            // render above chart
            renderer_1.opposite = true;
            renderer_1.minGridDistance = 25;
        }
        if (target instanceof charts_1.AxisRendererY) {
            renderer.minGridDistance = 30;
        }
    }
    if (target instanceof charts_1.ValueAxis) {
        var valueAxis = target;
        // https://www.amcharts.com/docs/v4/reference/valueaxis/#maxPrecision_property
        valueAxis.maxPrecision = 1;
        valueAxis.title = new core_1.Label();
        valueAxis.title.fontSize = "12px";
        if (valueAxis.tooltip) {
            valueAxis.tooltip.disabled = true;
        }
    }
    if (target instanceof charts_1.Series) {
        var series = target;
        series.strokeWidth = 3;
        if (series.tooltip) {
            series.tooltip.autoTextColor = true;
        }
        // animation properties
        series.defaultState.transitionDuration = 0;
        series.hiddenState.transitionDuration = 0;
        series.hiddenState.properties.opacity = 0;
        series.showOnInit = false;
    }
}
exports.snTheme = snTheme;
